import React, { Component } from 'react';
import { Table, Button, Card, Statistic, Divider, message } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import ModalAppointAdd from './ModalAppointAdd';
import './tableAppoint.less';

const typeFont = ['押金', '工位收入', '地址收入'];

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.dataSource || [],
      visible: false,
    };
  }

  setPayableData = data => {
    this.setState({
      data,
    });
  };

  handleDelete = index => {
    const { data } = this.state;
    data.splice(index, 1);
    this.props.handleChange(data);
    this.setState({ data });
  };

  handleAdd = params => {
    const { indeposit, price } = this.props;
    let { data } = this.state;
    if (this.index >= 0) {
      data[this.index] = params;
    } else {
      data = [...this.state.data, params];
    }
    if (+params.type === 0 && +params.price !== +indeposit) {
      message.warn('押金数额不正确！');
      return;
    }
    if (+this.getSum(data) > +indeposit + +price) {
      message.warn('付款约定超出合同款！');
      return;
    }
    this.setState({
      data,
    });
    this.props.handleChange(data);
    this.handleVisible(false);
  };

  handleVisible = (flag, record, index) => {
    this.record = record;
    this.index = index;
    this.setState({
      visible: !!flag,
    });
  };

  getSum = data => {
    return data.reduce((prev, current) => {
      return prev + current.price;
    }, 0);
  };

  handleClassName = record => {
    if (!(record.turns && record.turns.length > 0)) {
      return 'no-chiledren';
    }
  };

  expandedRowRender = (row, outIndex) => {
    const columns = [
      {
        title: '转结账单编号',
        dataIndex: 'payableNo',
        key: 'payableNo',
        render: (text, record) => (
          <Link to={`/incubator/bill/${record.payableUuid}/detail`}>{text}</Link>
        ),
      },
      {
        title: '转结金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record, innerIndex) => (
          <span>
            <a onClick={() => this.props.handleTurnEdit(record, outIndex, innerIndex)}>编辑</a>
            <Divider type="vertical" />
            <a onClick={() => this.props.handleTurnDelete(record, outIndex, innerIndex)}>删除</a>
          </span>
        ),
      },
    ];

    const data = row.turns;
    return data ? <Table columns={columns} dataSource={data} pagination={false} /> : null;
  };

  columns = () => {
    return [
      {
        title: '收入类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => <span>{typeFont[text]}</span>,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '付款金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '付款时间',
        dataIndex: 'date',
        key: 'date',
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record, index) => {
          return (
            <span>
              <a onClick={() => this.handleVisible(true, record, index)}>编辑</a>
              <Divider type="vertical" />
              <a onClick={() => this.handleDelete(index)}>删除</a>
              <Divider type="vertical" />
              <a onClick={() => this.props.handleCarry(index)}>转结</a>
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, visible } = this.state;
    return (
      <Card
        title="付款约定"
        extra={<Button onClick={() => this.handleVisible(true)}>添加</Button>}
        ref={ref => {
          this.payable = ref;
        }}
      >
        <Table
          className="nestedTable"
          rowClassName={this.handleClassName}
          columns={this.columns()}
          dataSource={data}
          pagination={false}
          expandedRowKeys={data.map((item, index) => index)}
          expandedRowRender={this.expandedRowRender}
          rowKey="index"
        />
        <Statistic
          style={{
            display: 'flex',
            lineHeight: '56px',
            justifyContent: 'flex-end',
          }}
          title="总计金额:"
          value={this.getSum(data) ? this.getSum(data).toFixed(2) : ''}
          valueStyle={{ marginLeft: '8px' }}
          suffix="元"
        />
        {visible ? (
          <ModalAppointAdd
            onCancel={() => this.handleVisible(false)}
            handleSubmit={this.handleAdd}
            data={this.record}
          />
        ) : null}
      </Card>
    );
  }
}

export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/comm/TableAppoint.js